<template>
  <div class="container">
    <h2>Voucher</h2>
    <voucher-form :form="form" />
    <br>

    <div class="spaced-row">
      <mad-button @click="clickCancel">
        <mad-icon mdi="arrow-left" />
      </mad-button>
      <div class="grow"></div>
      <mad-button color="brown" size="sm" @click="submit">
        <mad-icon mdi="check" />Save voucher
      </mad-button>
    </div>
  </div>
</template>

<script>
import VoucherForm from '../VoucherForm.vue'

export default {
  components: {
    VoucherForm,
  },

  data: () => ({
    form: {
      name: 'Your name here',
      logo: 'http://placehold.it/50x50',
      logo_placement: 'position:absolute;top:-60px;right:-75px;width:129px',
      background_color: '#000000',
      button_color: '#DAA520',
      button_text_color: '#FFFFFF',
      coffee_color: '#8B0000',
      coffee_image: 'http://placehold.it/50x50',
      courtesy_color: '#FFFFFF',
      courtesy_text: 'Your courtesy text here',
      free_color: '#FFFFFF',
    },
  }),

  computed: {
    iframeSrc() {
      const baseUrl = 'http://localhost:3000/preview'
      const data = this.form
      const url =
        baseUrl +
        '?' +
        Object.entries(data)
          .map(keyVal => `${keyVal[0]}=${encodeURIComponent(keyVal[1])}`)
          .join('&')
      return url
    },
  },

  methods: {
    async submit() {
      await this.$store.dispatch('createLocation', {
        ...this.form,
        user: this.$store.state.user,
      })
      this.$router.push(`/locations`)
    },
    clickCancel() {
      this.$router.push('/locations')
    },
  },
}
</script>

<style>
</style>
